import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { RichTextEditor } from '../../shared-components/RichTextEditor';
import './BodyMessageSection.scss';
import { Text } from '@fluentui/react-components';

const BodyMessageSectionImpl: React.FC = () => {
  const {
    createOrEditEmailTemplatePageUiStore,
  } = useStores();

  const handleContentChanged = (newValue: string): void => {
    createOrEditEmailTemplatePageUiStore.setEmailTemplateRequestBody<string>({
      key: 'bodyMessage',
      value: newValue
    });
  };

  return (
    <div className='body-message-section'>
      <Text weight='semibold'>Body message</Text>
      <RichTextEditor
        key={createOrEditEmailTemplatePageUiStore.selectedEmailTemplate?.emailTemplateId || 'new-template'}
        value={createOrEditEmailTemplatePageUiStore.emailTemplateRequestBody?.bodyMessage}
        onChange={(content) => handleContentChanged(content)}
        errorMessage={createOrEditEmailTemplatePageUiStore.isBeingValidated
          ? createOrEditEmailTemplatePageUiStore.emailTemplateRequestValidation.fieldErrors.bodyMessage?.join(' ')
          : undefined}
      />
    </div>
  );
};

export const BodyMessageSection = observer(BodyMessageSectionImpl);
